<template>
	<div class="site-section interior">
    <section class="hero is-medium is-black is-vcentered">
      <div class="columns is-tablet">
        <div class="column is-one-third is-one-quarter-tablet is-full-mobile">
          <img src="../../assets/hero-daddy-events.png">
        </div>
        <div class="column">
          <div class="hero-body">
            <h1 class="is-size-1 lucky-title">
              Utility
            </h1>
            <div class="intro">We are extremely grateful for all our holders, and are working VERY hard behind the scenes to provide enormous utility.</div>
          </div>
        </div>
      </div>
    </section>
    <section class="body-content">
      <p>While this is not a comprehensive list, some of our planned utility includes the following!</p>
      <ul style="list-style: disc">
        <li>
          <h3>Ask A Question!</h3>
          <p>Holders will have direct access to us and be able to ask questions about anything related web3 - or life, the universe, and everything!</p>
        </li>
        <li>
          <h3>NFD Academy (Advanced)</h3>
          <p>Our 101 and Blockchain basics are free, but we're working on much more advanced classes for our holders!</p>
        </li>
        <li>
          <h3>Web 3 Workshops</h3>
          <p>Our 101 and Blockchain basics are free, but we're working on much more advanced classes for our holders!</p>
        </li>
        <li>
          <h3>Newsletter</h3>
          <p>We provide a regular newsletter that give holders and frens alike details on what we're up to, events and classes, etc.  Contact us if you'd like to sign up!</p>
        </li>
        <li>
          <h3>Skinned Games</h3>
          <p>We are working on building a suite of skinned games that will include your NFDaddy!</p>
        </li>
        <li>
          <h3>Marketplace</h3>
          <p>Shh...this one is a secret.  More info will be provided when the time is right!</p>
        </li>
        <li>
          <h3>Exclusive Merch</h3>
          <p>We are working on developing exclusive merch that will only be available to our holders.  Duckys everywhere!</p>
        </li>
      </ul>
    </section>
	</div>
</template>
<script>
/* eslint-disable no-console */
export default {
  name: "WorkshopSignup",
  methods: {

  },
};
/* eslint-enable no-console */
</script>
<style scoped>


</style>